// This file is now DEPRECATED
// Use the FeatureFlagsProvider context instead

export { useFeatureFlags } from "../context/FeatureFlagsProvider";
